import * as React from "react";
import { Modal, ModalFooter } from "@grandvisionhq/common";
import { Util } from "@grandvisionhq/forms";
import { useSelector, useDispatch } from "@grandvisionhq/state";
import { useBaseSummarySlot } from "../../../../slots/summaries/slots/summaries/summary-context.js";
import { ShippingObjectTypes } from "../../../../state.js";
import { updateShippingDetails } from "../../../../StepShipping/StepShipping/actions.js";
import { getContactDetailsFormData, getShippingData } from "../../../../StepShipping/StepShipping/selectors.js";
import { CheckoutForm } from "../../../../components/Forms/components/Forms/CheckoutForm.js";
import { FormFieldsWithCart } from "../../../../components/FormFieldsWithCart/components/FormFieldsWithCart/FormFieldsWithCart.js";
import { useIsFormSlotAvailable } from "../../../../slots/forms/slots/forms/form-context.js";
const EditableContactDetailsSummary = ({ labels }) => {
  const isContactFormAvailable = useIsFormSlotAvailable(ShippingObjectTypes.ContactDetails);
  const [ContactDetailsFormData, setContactDetailsFormData] = React.useState();
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const { Slots } = useBaseSummarySlot();
  const contactDetailsInitialData = useSelector(getContactDetailsFormData);
  const dispatch = useDispatch();
  const contactDetailsData = useSelector(getShippingData)?.contactDetails;
  const hasData = React.useMemo(
    () => contactDetailsData && !Object.values(contactDetailsData).every((x) => x === null || x === ""),
    [contactDetailsData]
  );
  const ContactDetailsSummarySlot = Slots.contactDetails;
  if (!ContactDetailsSummarySlot && hasData) {
    console.error(
      "This opco is misconfigured. It has contact details data, but no contact details summary card setup."
    );
  }
  if (!ContactDetailsSummarySlot || !hasData) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, isContactFormAvailable && /* @__PURE__ */ React.createElement(
    Modal,
    {
      isOpen: isModalOpen,
      onModalClose: () => setIsModalOpen(false),
      showIcon: true,
      footer: /* @__PURE__ */ React.createElement(
        ModalFooter,
        {
          ctaCaption: labels?.editModal?.save,
          onCta: () => {
            if (!ContactDetailsFormData?.formValid) {
              Util.focusToTopErrorFieldOnScreen();
            } else {
              ContactDetailsFormData && dispatch(updateShippingDetails({ form: ContactDetailsFormData }));
              setIsModalOpen(false);
            }
          },
          onCancel: () => setIsModalOpen(false)
        }
      )
    },
    /* @__PURE__ */ React.createElement(
      CheckoutForm,
      {
        formName: "contactDetails",
        "data-t": "contactDetails",
        initialFormState: contactDetailsInitialData,
        onChange: (formData) => setContactDetailsFormData(formData)
      },
      /* @__PURE__ */ React.createElement(FormFieldsWithCart, { formName: ShippingObjectTypes.ContactDetails })
    )
  ), hasData && /* @__PURE__ */ React.createElement(
    ContactDetailsSummarySlot,
    {
      actions: { onEdit: () => setIsModalOpen(true) },
      values: contactDetailsData
    }
  ));
};
export {
  EditableContactDetailsSummary,
  EditableContactDetailsSummary as default
};
//# sourceMappingURL=EditableContactDetailsSummary.js.map
